import {Validators} from "@angular/forms";
import {
  IWhiteLabelSettingsSchema,
  WhiteLabelSettingsFormKeys,
  WhiteLabelSettingsTab
} from "@atlas-workspace/shared/models";


export const whiteLabelHexColorInputPattern = /^#?([A-Fa-f0-9]{6})$/;

const whiteLabelHexColorInputValidators = [
  Validators.required,
  Validators.pattern(whiteLabelHexColorInputPattern),
];
const whiteLabelBorderRadiusInputValidators = [
  Validators.required,
];

export const whiteLabelSettingsWebSchema: IWhiteLabelSettingsSchema[] = [
  // Assets
  {
    title: 'WL_builder.Assets',
    isAssets: true,
    inputs: [
      {
        formControlName: WhiteLabelSettingsFormKeys.LogoFile,
        isAssets: true,
        boundFileKeys: [WhiteLabelSettingsFormKeys.LogoUrl, WhiteLabelSettingsFormKeys.LogoFileId],
      }
    ]
  },
  // General colors
  {
    title: 'WL_builder.Colors',
    description: 'WL_builder.Colors_description',
    inputs: [
      {
        formControlName: WhiteLabelSettingsFormKeys.HeaderColor,
        labelTranslateKey: 'WL_builder.Header_color',
        previewStyleVariable: '--wl-headerColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '030D21',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.BackgroundColor,
        labelTranslateKey: 'WL_builder.Background_color',
        previewStyleVariable: '--wl-backgroundColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'F7F7F8',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.BorderColor,
        labelTranslateKey: 'WL_builder.Border_color',
        previewStyleVariable: '--wl-borderColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'EAECF0',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.BorderHoverColor,
        labelTranslateKey: 'WL_builder.Border_hover_color',
        previewStyleVariable: '--wl-borderHoverColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'C4C9D4',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SidebarTabSelectedState,
        labelTranslateKey: 'WL_builder.Sidebar_tab_selected_state',
        previewStyleVariable: '--wl-sidebarTabSelectedState',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'EAECF0',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SidebarTabHoveredState,
        labelTranslateKey: 'WL_builder.Sidebar_tab_hovered_state',
        previewStyleVariable: '--wl-sidebarTabHoveredState',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'F1F2F4',
      },
      {
        // TODO: hide temporarily [https://agilie.atlassian.net/browse/AT-12352?focusedCommentId=212133]
        hidden: true,
        formControlName: WhiteLabelSettingsFormKeys.CheckboxColor,
        labelTranslateKey: 'WL_builder.Checkbox_color',
        previewStyleVariable: '--wl-checkboxColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '0055FF',
      },
      {
        // TODO: hide temporarily [https://agilie.atlassian.net/browse/AT-12352?focusedCommentId=212133]
        hidden: true,
        formControlName: WhiteLabelSettingsFormKeys.CheckboxHoverColor,
        labelTranslateKey: 'WL_builder.Checkbox_hover_color',
        previewStyleVariable: '--wl-checkboxHoverColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '0044CC',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.TabSelectedState,
        labelTranslateKey: 'WL_builder.Tab_selected_state',
        previewStyleVariable: '--wl-tabSelectedState',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '0055FF',
      },
      {
        // TODO: hide temporarily [https://agilie.atlassian.net/browse/AT-12352?focusedCommentId=212133]
        hidden: true,
        formControlName: WhiteLabelSettingsFormKeys.TabHoveredState,
        labelTranslateKey: 'WL_builder.Tab_hovered_state',
        previewStyleVariable: '--wl-tabHoveredState',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '0044CC',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.OptionsHeaderColor,
        labelTranslateKey: 'WL_builder.Options_dashboard_header',
        previewStyleVariable: '--wl-optionsHeaderColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'EAECF0',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.AccentColor,
        labelTranslateKey: 'WL_builder.Accent_color',
        previewStyleVariable: '--wl-accentColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '0055FF',
      },
    ]
  },
  // Text
  {
    title: 'WL_builder.Text',
    description: 'WL_builder.Text_description',
    inputs: [
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryTextColor,
        labelTranslateKey: 'WL_builder.Primary',
        previewStyleVariable: '--wl-primaryTextColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '14181F',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryTextColor,
        labelTranslateKey: 'WL_builder.Secondary',
        previewStyleVariable: '--wl-secondaryTextColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '686E79',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.PlaceholderTextColor,
        labelTranslateKey: 'WL_builder.Placeholder',
        previewStyleVariable: '--wl-placeholderTextColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '8F96A3',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.DisabledTextColor,
        labelTranslateKey: 'WL_builder.Disabled',
        previewStyleVariable: '--wl-disabledTextColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'C4C9D4',
      },
    ]
  },
  // Primary button
  {
    title: 'WL_builder.Button',
    description: 'WL_builder.Button_desc',
    inputs: [
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryButtonBackgroundRest,
        labelTranslateKey: 'WL_builder.Primary_button_background_rest',
        previewStyleVariable: '--wl-primaryButtonBackgroundRest',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'E5EEFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryButtonBackgroundHover,
        labelTranslateKey: 'WL_builder.Primary_button_background_hover',
        previewStyleVariable: '--wl-primaryButtonBackgroundHover',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'CCDDFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryButtonBackgroundDisabled,
        labelTranslateKey: 'WL_builder.Primary_button_background_disabled',
        previewStyleVariable: '--wl-primaryButtonBackgroundDisabled',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'E5EEFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryButtonBorderRest,
        labelTranslateKey: 'WL_builder.Border_color',
        previewStyleVariable: '--wl-primaryButtonBorderRest',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'E5EEFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryButtonBorderHover,
        labelTranslateKey: 'WL_builder.Border_hover_color',
        previewStyleVariable: '--wl-primaryButtonBorderHover',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'E5EEFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryButtonBorderDisabled,
        labelTranslateKey: 'WL_builder.Border_disabled_color',
        previewStyleVariable: '--wl-primaryButtonBorderDisabled',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'CCDDFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryButtonTextColorRest,
        labelTranslateKey: 'WL_builder.Text_color',
        previewStyleVariable: '--wl-primaryButtonTextColorRest',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '0055FF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryButtonTextColorHover,
        labelTranslateKey: 'WL_builder.Text_hover',
        previewStyleVariable: '--wl-primaryButtonTextColorHover',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '0044CC',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.PrimaryButtonTextColorDisabled,
        labelTranslateKey: 'WL_builder.Text_disabled',
        previewStyleVariable: '--wl-primaryButtonTextColorDisabled',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '99bbff',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.ButtonCornerRadius,
        labelTranslateKey: 'WL_builder.Corner_radius',
        isBorderRadius: true,
        mask: '99',
        previewStyleVariable: '--wl-buttonCornerRadius',
        validators: whiteLabelBorderRadiusInputValidators,
        defaultValue: 20,
      },
    ]
  },
  // Secondary button
  {
    title: 'WL_builder.Button_secondary',
    description: 'WL_builder.Button_secondary_desc',
    inputs: [
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonBackgroundRest,
        labelTranslateKey: 'WL_builder.Primary_button_background_rest',
        previewStyleVariable: '--wl-secondaryButtonBackgroundRest',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'FFFFFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonBackgroundHover,
        labelTranslateKey: 'WL_builder.Primary_button_background_hover',
        previewStyleVariable: '--wl-secondaryButtonBackgroundHover',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'FFFFFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonBackgroundDisabled,
        labelTranslateKey: 'WL_builder.Primary_button_background_disabled',
        previewStyleVariable: '--wl-secondaryButtonBackgroundDisabled',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'FFFFFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonBorderRest,
        labelTranslateKey: 'WL_builder.Border_color',
        previewStyleVariable: '--wl-secondaryButtonBorderRest',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'EAECF0',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonBorderHover,
        labelTranslateKey: 'WL_builder.Border_hover_color',
        previewStyleVariable: '--wl-secondaryButtonBorderHover',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'C4C9D4',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonBorderDisabled,
        labelTranslateKey: 'WL_builder.Border_disabled_color',
        previewStyleVariable: '--wl-secondaryButtonBorderDisabled',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'FFFFFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonTextColorRest,
        labelTranslateKey: 'WL_builder.Text_color',
        previewStyleVariable: '--wl-secondaryButtonTextColorRest',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '14181F',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonTextColorHover,
        labelTranslateKey: 'WL_builder.Text_hover',
        previewStyleVariable: '--wl-secondaryButtonTextColorHover',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '14181F',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonTextColorDisabled,
        labelTranslateKey: 'WL_builder.Text_disabled',
        previewStyleVariable: '--wl-secondaryButtonTextColorDisabled',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'FFFFFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.SecondaryButtonCornerRadius,
        labelTranslateKey: 'WL_builder.Corner_radius',
        isBorderRadius: true,
        mask: '99',
        previewStyleVariable: '--wl-secondaryButtonCornerRadius',
        validators: whiteLabelBorderRadiusInputValidators,
        defaultValue: 32,
      },
    ]
  },
];


export const whiteLabelSettingsEmailSchema: IWhiteLabelSettingsSchema[] = [
  // Assets
  {
    title: 'WL_builder.Assets',
    isAssets: true,
    inputs: [
      {
        formControlName: WhiteLabelSettingsFormKeys.EmailLogoFile,
        isAssets: true,
        boundFileKeys: [WhiteLabelSettingsFormKeys.EmailLogoUrl, WhiteLabelSettingsFormKeys.EmailLogoFileId],
      }
    ]
  },
  // General colors
  {
    title: 'WL_builder.Colors',
    description: 'WL_builder.Colors_description',
    inputs: [
      {
        formControlName: WhiteLabelSettingsFormKeys.EmailBorderColor,
        labelTranslateKey: 'WL_builder.Border_color',
        previewStyleVariable: '--wl-emailBorderColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'EAECF0',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.EmailBackgroundColor,
        labelTranslateKey: 'WL_builder.Background_color',
        previewStyleVariable: '--wl-emailBackgroundColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'FFFFFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.EmailLinkColor,
        labelTranslateKey: 'WL_builder.Email_link_color',
        previewStyleVariable: '--wl-emailLinkColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '0055FF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.EmailPrimaryTextColor,
        labelTranslateKey: 'WL_builder.Text_color',
        previewStyleVariable: '--wl-emailPrimaryTextColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '14181F',
      },
    ]
  },
  // Button
  {
    title: 'WL_builder.Email_button',
    description: 'WL_builder.Email_button_description',
    inputs: [
      {
        formControlName: WhiteLabelSettingsFormKeys.EmailButtonBackgroundColor,
        labelTranslateKey: 'WL_builder.Background_color',
        previewStyleVariable: '--wl-emailButtonBackgroundColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'E5EEFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.EmailButtonBorderColor,
        labelTranslateKey: 'WL_builder.Border_color',
        previewStyleVariable: '--wl-emailButtonBorderColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: 'FFFFFF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.EmailButtonTextColor,
        labelTranslateKey: 'WL_builder.Text_color',
        previewStyleVariable: '--wl-emailButtonTextColor',
        validators: whiteLabelHexColorInputValidators,
        defaultValue: '0055FF',
      },
      {
        formControlName: WhiteLabelSettingsFormKeys.EmailButtonBorderRadius,
        labelTranslateKey: 'WL_builder.Corner_radius',
        isBorderRadius: true,
        mask: '99',
        previewStyleVariable: '--wl-emailButtonBorderRadius',
        validators: whiteLabelBorderRadiusInputValidators,
        defaultValue: 32,
      },
    ]
  },
];

export const whiteLabelSettingsSchema = {
  [WhiteLabelSettingsTab.Web]: whiteLabelSettingsWebSchema,
  [WhiteLabelSettingsTab.Email]: whiteLabelSettingsEmailSchema,
};
